import moment from 'moment'

export const isValidDate = str => !str ? true : moment(str, 'DD/MM/YYYY').isValid();

export const isValidTime = str => {
  if (!str) return true;
  const [h, m] = str.split(':').map(n => parseInt(n, 10));
  return h >= 0 && h < 24 && m >= 0 && m < 60;
}

export const isValidPhone = str => {
  if (!str) return true;
  return str.replace(/[^0-9]/g, '').length >= 9;
};

export const readDate = (str, defaultValue = null) => {
  if (str && isValidDate(str)) return moment(str, 'DD/MM/YYYY').format('YYYYMMDD');
  return defaultValue;
};

export const readHm = str => {
  if (str && isValidTime(str)) {
    const [h, m] = str.split(':').map(n => parseInt(n, 10));
    return h * 3600 + m * 60;
  }
  return null;
};

export const moneyToValue = str => {
  return str ? parseFloat(str.replace('R$ ', '').replace(/\./g, '').replace(',', '.'), 10): 0;
};

export const toHm = (secs, emptyStr = '-') => {
  if (secs >= 0) {
    const h = Math.floor(secs / 3600);
    const m = String(Math.floor((secs % 3600) / 60)).padStart(2, '0');
    return `${h}:${m}`;
  }
  return emptyStr;
};

export const timeRange = (start, finish) => {
  const hasStart = start >= 0 && start !== null;
  const hasFinish = finish >= 0 && finish !== null;
  return hasStart && hasFinish ? `de ${toHm(start)} até ${toHm(finish)}`
    : hasStart ? `entrada às ${toHm(start)}` : `saída às ${toHm(finish)}`
};

export const toDay = str => {
  const y = str.slice(0, 4);
  const m = str.slice(4, 6);
  const d = str.slice(6, 8);
  return `${d}/${m}/${y}`;
};

export const toDigits = str => {
  if (!str) return;
  return str.replace(/[^0-9]/g, '');
};



// WEBPACK FOOTER //
// ./src/helpers/form.js